import { render, staticRenderFns } from "./Login_2.vue?vue&type=template&id=114b4824&scoped=true&"
import script from "./Login_2.vue?vue&type=script&lang=js&"
export * from "./Login_2.vue?vue&type=script&lang=js&"
import style0 from "./Login_2.vue?vue&type=style&index=0&id=114b4824&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114b4824",
  null
  
)

export default component.exports